module.exports = __webpack_public_path__ + "img/long-boucherie.9ae98226.png";